export const hasPropUpdated = (prop, prevProp) => (
  prop && prevProp !== prop
)
